import React, { useState, useEffect } from 'react'
import { getCurrentDate } from '../../Utils/Dateutils';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox
} from '@mui/material';
import TitleBar from '../TitleBar';
import { ReceiptMenu } from '../TitleList';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Dropdown from '../FieldsComponents/Dropdown';
import RadioComponent from '../FieldsComponents/RadioComponent';
import TextareaComponent from '../FieldsComponents/TextareaComponent';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm, selectParty } from '../Selectors/Master/ItemSelectors';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import axios from 'axios';
import { insertSaleReceipt } from '../../Store/PHPSlice/ReceiptApi/receiptApi';

const SaleEntryReceipt = () => {
    const [lumplist, setLumplist] = useState([]);
    const [billList, setBillList] = useState([]);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        firmId: '',
        empId: '',
        rptNo: '',
        billNo: '',
        partyId: '',
        total: '0',
        totPaid: '0',
        netBal: '0',
        narr: '',
        payM: 'cash',
        payAmt: '',
        balAmt: '',
        bankNm: '',
        chqNo: '',
        chqdt: '',
        trnsId: '',
        payType: '',
        userId: userdata?.ID
    });

    const dispatch = useDispatch();
    const firmList = useSelector(selectFirm);
    const partyList = useSelector(selectParty);

    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
    }, [dispatch]);

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' }
    ];


    const isDesktop = useMediaQuery('(min-width:768px)');
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // If the field is 'payAmt', ensure it's not greater than totbill
        if (name === "payAmt") {
            const numericValue = parseFloat(value) || 0;
            const maxAllowed = parseFloat(formData.totbill) || 0;

            // Limit payAmt to totbill
            if (numericValue > maxAllowed) {
                return; // Do nothing if exceeds total bill
            }

            const balamt = maxAllowed - numericValue;

            setFormData({
                ...formData,
                [name]: numericValue,
                balAmt: balamt
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };




    const dropdownlistfirst = [
        {
            label: 'Firm Name',
            id: 'firmId',
            options: firmList?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Party',
            id: 'partyId',
            options: partyList?.data || [],
            value: formData.partyId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'partyId', value: newValue ? newValue.ID : '' } }, 'partyId'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            }
        },
        // {
        //     label: 'Bill No.',
        //     id: 'billNo',
        //     options: billList || [],
        //     value: formData.billNo,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'billNo', value: newValue ? newValue.ID : '' } }, 'billNo'),
        //     getOptionLabel: (option) => option.billNo || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        // },

    ];
    // console.log(billList)


    const dropdownlistsecond = [
        {
            label: 'Bill No.',
            id: 'billNo',
            options: billList || [],
            value: formData.billNo,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'billNo', value: newValue ? newValue.ID : '' } }, 'billNo'),
            getOptionLabel: (option) => option.billNo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
    ];

    const handleDropdownChange = async (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

        switch (dropdownType) {
            case 'firmId':
                if (value) {
                    const selectFirm = firmList?.data?.find((item) => item.ID === value)?.firmNm2;
                    // console.log(selectFirm);
                    const receiptno = `${selectFirm}-1`;
                    setFormData(prev => ({
                        ...prev,
                        rptNo: receiptno
                    }));
                }
                break;
            case 'partyId':
                if (value && formData.firmId !== '') {
                    const data = {
                        firmId: formData.firmId,
                        partyId: value
                    };
                    fetchSaleInvBillNos(data);
                }
                break;
            case 'firmId':
                if (value && formData.partyId !== '') {
                    const data = {
                        firmId: value,
                        partyId: formData.partyId
                    };
                    fetchSaleInvBillNos(data);
                }
                break;
            case 'billNo':
                if (value) {
                    const selectnetamt = billList?.find(item => item.ID === value)?.net_amt;
                    // console.log(billList)
                    setFormData(prev => ({
                        ...prev,
                        totbill: selectnetamt,
                        netBal: selectnetamt
                    }));
                }
            default:
                break;
        };
    };

    const fields01 = [
        { label: 'Receipt No.', name: 'rptNo', type: 'readOnly' },
        { label: 'Total', name: 'total', type: 'readOnly' },
        // { label: 'Total Paid Amt', name: 'totPaid', type: 'readOnly' },
        // { label: 'Net Balance', name: 'netBal', type: 'readOnly' }
    ];

    const fields02 = [
        { label: 'Total Bill Amt', name: 'totbill', type: 'readOnly' },
        { label: 'Total Paid Amt', name: 'totPaid', type: 'readOnly' },
    ];

    const paymode = [
        { label: 'Cash', value: 'cash' },
        { label: 'Cheque', value: 'cheque' },
        { label: 'Online Pay', value: 'onlinepay' }
    ];

    const Amtfields = [
        { label: 'Paying Amt', name: 'payAmt' },
        { label: 'Balance Amount', name: 'balAmt', type: 'readOnly' }
    ];

    const paymodeTypes = [
        { label: 'Card Pay', ID: 'cardpay' },
        { label: 'Google Pay', ID: 'googlepay' },
        { label: 'Phone Pay', ID: 'phonepay' },
        { label: 'Paytm', ID: 'paytm' }
    ];

    const selectPaymentType = {
        'cheque': [
            { label: 'Bank Name', name: 'bnkNm' },
            { label: 'Cheque Number', name: 'chqNo' },
            { label: 'Cheque Date', name: 'chqdt', type: 'date' }
        ],
        'onlinepay': [
            { label: 'Transaction Id', name: 'trnsId' }
        ]
    };

    const selectPaymentType2 = [
        {
            label: 'Payment Type',
            id: 'payType',
            options: paymodeTypes || [],
            value: formData.payType,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'payType', value: newValue ? newValue.ID : '' } }, 'payType'),
            getOptionLabel: (option) => option.label || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const selectedPayOption = selectPaymentType[formData.payM];

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };
    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    const handleCheckboxChange = (index) => {
        const updatedList = [...lumplist];
        updatedList[index].checked = !updatedList[index].checked;
        setLumplist(updatedList);
    };


    const fetchSaleInvBillNos = async (id) => {
        const { firmId, partyId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getSaleInvBillNos&firmId=${firmId}&partyId=${partyId}`);
            const billNos = response?.data?.data;
            setBillList(billNos);

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    function postObj(formData) {
        const billno = billList?.find(val => val.ID === formData.billNo)?.billNo;
        const data = {
            dt: formData.dt,
            firmId: formData.firmId,
            partyId: formData.partyId,
            saleInvId: formData.billNo,
            receiptNo: formData.rptNo,
            total_amt: formData.totbill,
            paid_amt: formData.payAmt,
            paymode: formData.payM,
            billNo: billno,
            narr: formData.narr,
            userId: formData.userId
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const finaldata = postObj(formData);
        // console.log(finaldata);
        dispatch(insertSaleReceipt(finaldata))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Material Added");
                alert("Record Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };
    return (
        <>
            <TitleBar data={ReceiptMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Sale Receipt Entry</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {fields?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                {
                                    dropdownlistfirst && dropdownlistfirst?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {fields01?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                {
                                    dropdownlistsecond && dropdownlistsecond?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {fields02?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                <RadioComponent
                                    label="Payment Mode:"
                                    name="payM"
                                    value={formData.payM}
                                    options={paymode}
                                    onChange={handleInputChange}
                                    isDesktop={true} // Pass the actual value based on screen size
                                />

                                {
                                    formData.payM === 'onlinepay' && selectPaymentType2?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {selectedPayOption?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {Amtfields?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                <TextareaComponent
                                    label="Naration"
                                    name="narr"
                                    value={formData.narr}
                                    onChange={handleInputChange}
                                    isDesktop={isDesktop}
                                />


                                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                    <Table style={isDesktop ? { width: '70%' } : { width: '100%' }}>
                                        <TableBody>

                                            <TableRow>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Receipt No.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Date</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Paid Amount</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Print</TableCell>
                                            </TableRow>

                                        </TableBody>


                                    </Table>
                                </TableContainer>


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>

                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    )
}

export default SaleEntryReceipt;
